import {
  Avatar,
  CardHeader,
  Grid,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PrimaryOutlinedButton } from 'components';
import CertificateModal from '../certificate-modal';
import { ICertificate } from '../../../../interface';
import { getCertificateSummary } from '../certificate-modal/utils';

interface ViewCertificateProps {
  formTitle: string,
  certificate: ICertificate | null | undefined;
  handleCertificate: (certificate: ICertificate) => void;
  handleCertificateRemove: () => void;
  sessionTitle?: string;
  moduleTitles?: string[];
  enterprise?: {
    entLogo?: string | null;
    logo?: string | null;
    name?: string | null;
  } | null;
}

const ViewCertificate = ({
  certificate,
  handleCertificate,
  handleCertificateRemove,
  formTitle,
  sessionTitle,
  moduleTitles,
  enterprise,
}: ViewCertificateProps) => (
  <div>
    {!certificate?.title ? (
      <div>
        <CertificateModal
          add
          formTitle={formTitle}
          certificate={certificate}
          setCertificate={handleCertificate}
          sessionTitle={sessionTitle}
          moduleTitles={moduleTitles}
          enterprise={enterprise}
        />
      </div>
    ) : (
      <Grid container alignItems="center">
        <Grid item xs={10}>
          <CardHeader
            avatar={(
              <Avatar
                src={certificate.badge?.imageUrl || certificate.logos?.[0]?.logoUrl || ''}
                sx={{ width: 40, height: 40 }}
              />
            )}
            title={<Typography variant="h4">{certificate.title}</Typography>}
            subheader={(
              <div style={{ lineBreak: 'anywhere' }}>
                {getCertificateSummary(certificate)}
              </div>
            )}
            subheaderTypographyProps={{ noWrap: false }}
          />
        </Grid>
        <Grid item xs sx={{ textAlign: 'right' }}>
          <Grid container>
            <Grid item>
              <CertificateModal
                add={false}
                formTitle={formTitle}
                certificate={certificate}
                setCertificate={handleCertificate}
                sessionTitle={sessionTitle}
                moduleTitles={moduleTitles}
                enterprise={enterprise}
              />
            </Grid>
            <Grid item>
              <PrimaryOutlinedButton
                onClick={handleCertificateRemove}
                startIcon={<CloseIcon />}
              >
                Remove
              </PrimaryOutlinedButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )}
  </div>
);

ViewCertificate.defaultProps = {
  sessionTitle: '',
  moduleTitles: [],
  enterprise: null,
};

export default ViewCertificate;
